import { AxiosAdapter } from '../../_config/v2/adapters/axios/axios.adapter';
import { Http } from '../../_config/v2/adapters/axios/axios.protocols';
import { Enviroment } from '../../_config/constants/enviroment-v2.constant';

export class Service {
	async getTemplate({ template, location }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/template/get-template/${template}/location/${location}/${Enviroment.ROOT_PLATFORM}`,
			params: { active: true, pharmacy: Enviroment.ROOT_PHARMACY, country: Enviroment.COUNTRY },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
	async getModuleByTemplate({ template, query }) {
		return new AxiosAdapter({
			method: Http.GET,
			url: `${Enviroment.API_PHARMACY}/template/get-modules-by-template/${template}/${Enviroment.ROOT_PLATFORM}/${Enviroment.COUNTRY}/${Enviroment.ROOT_PHARMACY}`,
			params: { location: query },
		})
			.request()
			.then((response) => {
				return response;
			})
			.catch((e) => {
				return e;
			});
	}
}
